import SendDocForm from './SendDocForm';
import { useEnumContext } from 'contexts/enumContext';

export default function SendDocContainer() {
    const { data } = useEnumContext({ size: 100, enumName: 'FileType' });
    return <SendDocForm typeOfDocument={data} />;
}
